import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 24px;
  > div {
    color: #757575;
    font-size: 14px;
    font-weight: 700;
    padding-bottom: 4px;
    svg {
      margin-left: 4px;
      width: 12px;
    }
  }
  textarea {
    margin-bottom: 12px;
  }
  .ant-checkbox-wrapper > span + span {
    color: #363636;
    font-weight: 500;
  }
`
